export const LAZY_TURBO_FRAME_IDS = [
  "recent-work",
  "followed_tenders_kanban",
  "followed_tenders_summary",
  "overlay_modal",
  "summary"
]
